import { defineComponent, createElementBlock, createCommentVNode, openBlock, createElementVNode, Fragment, renderList, normalizeClass, createBlock, withCtx, toDisplayString } from 'vue';
import _sfc_main$1 from './basler-components.es133.js';

const _hoisted_1 = ["aria-label"];
const _hoisted_2 = { class: "customer-account-nav__list customer-account-nav__list--main" };
const _hoisted_3 = { class: "customer-account-nav__link-text" };
const _hoisted_4 = { class: "customer-account-nav__section-title" };
const _hoisted_5 = { class: "customer-account-nav__list customer-account-nav__list--sub" };
const _hoisted_6 = { class: "customer-account-nav__link-text" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "CustomerAccountNav",
  props: {
    navAriaLabel: {},
    items: {}
  },
  emits: ["link-click"],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const onClick = (item) => {
      emit("link-click", item);
    };
    return (_ctx, _cache) => {
      return _ctx.items?.length ? (openBlock(), createElementBlock("nav", {
        key: 0,
        class: "customer-account-nav",
        "aria-label": _ctx.navAriaLabel
      }, [
        createElementVNode("ul", _hoisted_2, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.items, (navItem) => {
            return openBlock(), createElementBlock("li", {
              key: navItem.text,
              class: normalizeClass(["customer-account-nav__item", { "is-active": navItem.isActive }])
            }, [
              navItem.link && navItem.text ? (openBlock(), createBlock(_sfc_main$1, {
                key: 0,
                uri: navItem.link.uri,
                class: "customer-account-nav__link",
                onClick: ($event) => onClick(navItem)
              }, {
                default: withCtx(() => [
                  createElementVNode("span", _hoisted_3, toDisplayString(navItem.text), 1)
                ]),
                _: 2
              }, 1032, ["uri", "onClick"])) : createCommentVNode("", true),
              navItem.text && navItem.items ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                createElementVNode("span", _hoisted_4, toDisplayString(navItem.text), 1),
                createElementVNode("ul", _hoisted_5, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(navItem.items, (subnavItem) => {
                    return openBlock(), createElementBlock("li", {
                      key: subnavItem.text,
                      class: normalizeClass(["customer-account-nav__item", { "is-active": subnavItem.isActive }])
                    }, [
                      subnavItem.link && subnavItem.text ? (openBlock(), createBlock(_sfc_main$1, {
                        key: 0,
                        uri: subnavItem.link.uri,
                        class: "customer-account-nav__link",
                        "aria-current": subnavItem.isActive ? "page" : void 0,
                        onClick: ($event) => onClick(subnavItem)
                      }, {
                        default: withCtx(() => [
                          createElementVNode("span", _hoisted_6, toDisplayString(subnavItem.text), 1)
                        ]),
                        _: 2
                      }, 1032, ["uri", "aria-current", "onClick"])) : createCommentVNode("", true)
                    ], 2);
                  }), 128))
                ])
              ], 64)) : createCommentVNode("", true)
            ], 2);
          }), 128))
        ])
      ], 8, _hoisted_1)) : createCommentVNode("", true);
    };
  }
});

export { _sfc_main as default };
